var map = {
	"./analysing-pad.png": "89dd",
	"./attend-fall-green.png": "44d7",
	"./attend-fall-grey.png": "7119",
	"./attend-fall.png": "2bcd",
	"./body-position-green.svg": "5d67",
	"./body-position-grey.svg": "16c2",
	"./body-position-red.svg": "95c0",
	"./change-position.png": "a29f",
	"./check-time-in-pad.png": "aa4f",
	"./diaper-not-use.png": "cca8",
	"./drop1-green.svg": "8308",
	"./drop1-grey.svg": "351e",
	"./drop1-red.svg": "fc77",
	"./drop2-green.svg": "5762",
	"./drop2-grey.svg": "6cbe",
	"./drop2-red.svg": "74b4",
	"./flat-battery.png": "49e1",
	"./monitor-pad.png": "fdae",
	"./pad-green.svg": "d16a",
	"./pad-grey.svg": "4230",
	"./pad-in-bin.png": "b574",
	"./pad-not-selected.png": "3f97",
	"./pad-white.svg": "870b",
	"./pad.svg": "a3bf",
	"./pod-unclipped.png": "4844",
	"./position-green.png": "84e3",
	"./position-grey.png": "fc48",
	"./position-white.jpg": "a031",
	"./red-pad.png": "ec90",
	"./replace-battery.png": "6f5d",
	"./sensor-disconnected-dark-grey.png": "6007",
	"./sensor-disconnected.png": "4858",
	"./simple-flat-battery.png": "001e",
	"./simple-lost-connection.png": "3391",
	"./simple-pad-gray.png": "3610",
	"./simple-pad-yellow.png": "951f",
	"./simple-pad.png": "204d",
	"./simple-replace-battery.png": "bf84",
	"./simple-reposition.png": "d486",
	"./temperature-green.svg": "ef1a",
	"./temperature-grey.svg": "bbcc",
	"./temperature-red.svg": "d1a7",
	"./time-in-pad-green.png": "358d",
	"./time-in-pad-grey.png": "500c",
	"./time-in-pad-red.png": "f4d7",
	"./time-in-pad-red2.png": "421c",
	"./wetsurface.png": "c704",
	"./wifi-lost-svgrepo-com.svg": "be43",
	"./wifi.png": "8d76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1f7";